import LeftAvatar from '../CopilotAvatar';
import Message from '../Message';
import styles from './style.module.less';
import { AgentType } from '../../type';
import { isMobile } from '../../../utils/utils';

type Props = {
    currentAgenticon?: any;
    currentAgent?: AgentType;
    onSendMsg: (value: string) => void;
    curSkill?: any;
};

const AgentTip: React.FC<Props> = ({ currentAgent, onSendMsg, currentAgenticon, curSkill }) => {
    if (!currentAgent) {
        return null;
    }
    return (
        <div className={styles.agentTip}>
            {!isMobile && <img src={currentAgenticon?.agent_icon} alt="" className={`${styles.leftAvatar}`} />}
            <Message position="left" bubbleClassName={styles.agentTipMsg}>
                <div className={styles.title}>
                    {/* 您好，智能助理【{currentAgent.name}
          】将与您对话，试着问： */}

                    {curSkill?.default_prompt || '您好，我是您的AI问数助手'}
                </div>
                <div className={styles.content}>
                    <div className={styles.examples}>
                        {currentAgent.examples?.length > 0 ? (
                            currentAgent.examples.map((example) => (
                                <div
                                    key={example}
                                    className={styles.example}
                                    onClick={() => {
                                        onSendMsg(example);
                                    }}
                                >
                                    “{example}”
                                </div>
                            ))
                        ) : (
                            <div className={styles.example}>{currentAgent.description}</div>
                        )}
                    </div>
                </div>
            </Message>
        </div>
    );
};

export default AgentTip;
